import store from 'store';

/**
 *
 * @return {Object[]}
 */
export default () => store.getState().General.modules;
